import { CardProductGallery } from '@/components/card/card-product/card-product-gallery';
import { AddToCart } from '@/shared/add-to-cart/add-to-cart';

export function cardProductInit(card) {
	new CardProductGallery(card.querySelector('.js-card-product-gallery'));
	new AddToCart(card.querySelector('.js-add-to-cart'));

	const modalOpener = card.querySelector('.js-modal-open');
	if (modalOpener) {
		modalOpener.addEventListener('click', () => {
			window.app.modal.open(modalOpener.dataset.modal);
		});
	}
}
